module.exports = __webpack_public_path__ + "b9fc62f34c8ec66585535ba2b81b76f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/G@2x.png
// module id = 832
// module chunks = 0